import React from 'react'
import styled from 'styled-components'
import { MarginProps } from 'styled-system'

import Box from 'components/Box'
import Flex from 'components/Flex'
import Text from 'components/Text'
import Icon from 'components/Icon'

type Step = {
  label: string
  value: string
}

type Props = MarginProps & {
  currentStep: Step['value']
  steps: Step[]
}

const Step: React.FC<Step & { isDone?: boolean; isAllDone?: boolean }> = ({ isDone, isAllDone, label }) => (
  <Box position="relative">
    {isAllDone && <Icon color="green" icon="check-circle" />}
    {!isAllDone && <Stroke isDone={isDone}>{isDone && <Fill />}</Stroke>}
    <Box
      position="absolute"
      left="-50%"
      // makes up for difference in icon vs styled.div
      bottom={`-${20 - (isAllDone ? 2.5 : 0)}px`}
    >
      <Text color={isDone ? 'defaultText' : 'disabledText'} ellipsis>
        {label}
      </Text>
    </Box>
  </Box>
)

const Progress: React.FC<Props> = ({ currentStep, steps, ...marginProps }) => {
  const currentStepIndex = steps.findIndex((i) => i.value === currentStep)

  return (
    <Flex gap="0px" minHeight="18px" {...marginProps}>
      {steps.map((i, stepIndex) => {
        const isDone = stepIndex <= currentStepIndex
        const isAllDone = currentStepIndex + 1 === steps.length
        const isLastStep = stepIndex + 1 >= steps.length
        return (
          <>
            <Step key={i.value} isAllDone={isAllDone} isDone={isDone} {...i} />
            {!isLastStep && <Stem />}
          </>
        )
      })}
    </Flex>
  )
}

const Stem = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.gray2};
  width: 6rem;
`

const Stroke = styled.div<{ isDone?: boolean }>`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ isDone, theme }) => (isDone ? theme.colors.gray3 : theme.colors.gray4)};
  border-radius: 50%;
  box-shadow: ${({ isDone, theme }) => (isDone ? `2px 2px 1px ${theme.colors.gray4}` : 'none')};
  height: 16px;
  width: 16px;
  position: relative;
`

const Fill = styled.div`
  background-color: ${({ theme }) => theme.colors.blue1};
  border-radius: 50%;
  height: 10px;
  width: 10px;
  position: absolute;
  top: 16%;
  left: 16%;
`

export default Progress
